// Return-to-page after login.
//
// When a logged-out user opens a protected page (e.g. a "Users on platform"
// Library link), they are sent to /login?redirect=<that page>, and after
// logging in they land on it instead of the default tab. The destination
// lives only in the login URL, so it is used once: as soon as the user leaves
// /login it is gone.

const REDIRECT_PARAM = "redirect";
const MAX_PATH_LENGTH = 2048;

// Only in-app pages — never another site ("//evil.com", "https://…") and never
// the bare "/home", which is where login goes anyway.
export const isSafePostLoginPath = (path) =>
  typeof path === "string" &&
  path.length <= MAX_PATH_LENGTH &&
  path.indexOf("/home/") === 0 &&
  path.indexOf("\\") === -1;

// For the logged-out catch-all redirect: the login URL that brings the user
// back to `location` after signing in (plain "/login" for any other page).
export const getLoginUrlFor = (location) => {
  const path = `${location.pathname || ""}${location.search || ""}`;
  if (!isSafePostLoginPath(path)) {
    return "/login";
  }
  return `/login?${REDIRECT_PARAM}=${encodeURIComponent(path)}`;
};

// The page this user should land on after logging in on /login?redirect=…,
// or null.
export const getPostLoginRedirect = (user) => {
  let path = null;
  try {
    if (window.location.pathname === "/login") {
      path = new URLSearchParams(window.location.search).get(REDIRECT_PARAM);
    }
  } catch (e) {
    return null;
  }
  if (!isSafePostLoginPath(path)) {
    return null;
  }
  // Trivvy pages carry the organization id; a page of another organization
  // (e.g. a link from a different account) is never used.
  const orgMatch = path.match(/^\/home\/trivia\/([a-f\d]{24})(\/|$)/i);
  const userOrgId = user && user.organizationId && user.organizationId._id;
  if (orgMatch && userOrgId && orgMatch[1] !== String(userOrgId)) {
    return null;
  }
  return path;
};
